export const currencyConvert = (amount: number | string) => {
  if (!amount) return amount;

  return Number(amount)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, '$&,');
};
